import React, { useEffect, useState } from 'react';

import { Button, Modal } from 'react-bootstrap';
import { useIntl } from 'react-intl';

import { useAppSelector } from 'hooks';
import { useAxios } from 'configs/requests';
import { Error, Loading } from 'components/Fetch';

import { ObservationContent } from './Observation';

interface IDeleteObservationModalProps {
  setShow: (show: boolean) => any;
  show: boolean;
  observation: ICarePlanObservationTask;
  onDeleteObservation: any;
  carePlanTemplate?: ICarePlanTemplate;
}

const DeleteObservationModal = ({
  show,
  setShow,
  observation,
  onDeleteObservation,
  carePlanTemplate
}: IDeleteObservationModalProps) => {
  const intl = useIntl();
  const patientUid = useAppSelector(({ patient }) => patient.data?.uid);
  const [error, setError] = useState<any>(false);

  const [{ loading, error: postError }, post] = useAxios(
    {
      url: carePlanTemplate
        ? '/clinician/2.0.0/CarePlanTemplate'
        : `/clinician/Patient/${patientUid}/CarePlan`,
      method: 'POST'
    },
    { manual: true }
  );

  const handleDelete = async () => {
    const observationToDelete = {
      ...observation,
      edit_status: 'deleted'
    };

    await post({
      data: {
        scheduled: [observationToDelete],
        carePlanTemplate
      }
    });

    onDeleteObservation(observation.id);
  };

  useEffect(() => {
    setError(postError);
  }, [postError, setError]);

  return (
    <Modal data-test="delete-observation-modal" show={show} onHide={() => setShow(false)}>
      <Modal.Header className="align-items-center">
        <Modal.Title>
          {intl.formatMessage({ id: 'deleteKey' }) +
            ' ' +
            intl.formatMessage({ id: 'observationKey' })}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <ObservationContent observation={observation} />
        {loading && <Loading className="mt-4" />}
        {error && (
          <Error
            retry={handleDelete}
            dismissible
            onClose={() => setError(false)}
            className="mt-4"
          />
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          data-test="delete-observation-modal-cancel"
          variant="link"
          onClick={() => setShow(false)}
        >
          {intl.formatMessage({ id: 'Cancel' })}
        </Button>
        <Button data-test="delete-observation-modal-submit" variant="danger" onClick={handleDelete}>
          {intl.formatMessage({ id: 'deleteKey' })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteObservationModal;
